<template>
  <div>
    <div v-if="this.fareEachAmount > 0 ? true : false">
      <div class="mt-3">
        <!-- <v-card rounded="1" style="font-size: 14px"> -->
        <div style="
            background-color: #0b446d;
            padding: 10px;
            border-top-right-radius: 10px;
            border-top-left-radius: 10px;
            color: white;
          ">
          <div class="d-flex align-items-center">
            <!-- <span>
                        <v-img :src="require('@/assets/airticket.png')" height="43px" width="50px"
                          style="filter: brightness(0) invert(1)" />
                      </span> -->
            <span style="font-size: 20px; font-weight: 500">{{
              $t("paymentContent.fareUpgrade.fareUpgradeHeading")
            }}</span>
          </div>
        </div>
        <v-radio-group v-model="selectedUpgrade" class="w-100">
          <div style="padding: 20px 15px">
            <div class="row gx-0" :style="isMobile ? { height: 'auto' } : { height: '100%' }">
              <v-card :class="[
                'upgrade',
                selectedUpgrade === 'basic' ? 'act-upgrate' : 'act-none',
              ]" style="
                  border: 1px solid lightgray;
                  padding: 10px 10px 25px 10px !important;
                " :style="isMobile ? { height: 'auto' } : { height: '100%' }" class="col-sm-6">
                <v-card-text>
                  <div class="d-flex justify-content-between">
                    <div>
                      <div class="up-title">
                        {{ BasicUpgrade?.option_text }}
                      </div>
                      <div>{{ BasicUpgrade?.option_tag }}</div>
                    </div>
                    <v-radio value="basic" class="mt-2" hide-details></v-radio>
                  </div>

                  <div v-if="BasicUpgradeval">
                    <div v-for="data in BasicUpgrade.feature_list" :key="data">
                      <div v-for="data1 in data" :key="data1">
                        <div class="d-flex mt-1">
                          <v-icon :color="data1.color">{{ data1.logo }}</v-icon>
                          <div class="ms-2" :style="{ 'font-weight': data1.style.fontweight }">
                            {{
                              data1.text.replaceAll("*", "").replaceAll("#", "")
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div style="height: 10%; margin-top: 8.9rem !important" class="mt-4">
                    <v-btn variant="outlined" block height="40" :class="selectedUpgrade === 'basic' ? 'upgradeButton' : ''
                      " @click="
                        selectedUpgrade = 'basic';
                      basicData();
                      ">
                      {{ $t("paymentContent.fareUpgrade.continueBasic") }}
                    </v-btn>
                  </div>
                </v-card-text>
              </v-card>

              <v-card :class="[
                'upgrade',
                selectedUpgrade === 'standard' ? 'act-upgrate' : 'act-none',
              ]" style="
                  border: 1px solid lightgray;
                  padding: 10px 10px 25px 10px !important;
                  
                " :style="isMobile ? { height: 'auto' } : { height: '100%' }" class="col-sm-6">
                <v-card-text>
                  <div class="d-flex justify-content-between">
                    <div>
                      <div class="up-title">
                        {{ standartUpgrade.option_text }}
                      </div>
                      <div>{{ standartUpgrade.option_tag }}</div>
                    </div>
                    <v-radio value="standard" class="mt-2" hide-details></v-radio>
                  </div>

                  <div v-if="standartval">
                    <div v-for="data in standartUpgrade.feature_list" :key="data">
                      <div v-for="data1 in data" :key="data1">
                        <div class="d-flex mt-1">
                          <v-icon :color="data1.color">{{ data1.logo }}</v-icon>
                          <div class="ms-2" :style="{ 'font-weight': data1.style.fontweight }">
                            {{ data1.text.replaceAll("*", "") }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="fareupgradeDataterms && fareupgradeDataterms.heading && fareupgradeDataterms.html_content">
                    <span data-bs-toggle="offcanvas" data-bs-target="#additionalinformation"
                      aria-controls="additionalinformation" style="
                                    font-size: 13px;
                                    font-weight: 600;
                                    color: rgb(13, 110, 253);
                                    text-decoration: underline;">Details</span>
                  </div>
                  <div class="mt-3">
                    <span style="font-size: 16px; font-weight: 500">
                      {{ currency }} {{ fareEachAmount }}
                    </span>
                    {{
                      $t("paymentContent.fareUpgrade.perPassenger")
                    }}(each-way)
                  </div>

                  <div style="height: 10%" class="mt-3">
                    <v-btn variant="outlined" height="40" :class="selectedUpgrade === 'standard'
                        ? 'upgradeButton'
                        : 'bt-upgrade'
                      " block class="bt-upgrade" @click="
                        selectedUpgrade = 'standard';
                      upgradeflowData();
                      ">
                      <!-- {{ $t("paymentContent.fareUpgrade.upgradeNow") }} -->
                      <span>{{
                        selectedUpgrade === "standard"
                          ? "Upgrade Selected"
                          : $t("paymentContent.fareUpgrade.upgradeNow")
                      }}</span>
                    </v-btn>
                    <br />
                  </div>

                  <div class="mt-2 d-flex check flex-wrap" v-if="selectedUpgrade === 'standard'">
                    <div style="display: flex;align-items: center">
                      <span class="mt-1">Selected</span>
                      <span class="ms-2 me-2">
                        <v-select v-model="selectpassData" :items="selectpass" variant="outlined"
                          density="compact"></v-select>
                      </span>
                    </div>
                    <div style="display:flex;flex-wrap: wrap;align-items: center;">
                      <span class="mt-1">Passenger(s)</span>
                      <span class="mt-1 ms-1" style="font-size: 14px; font-weight: 500">
                        {{ currency }} {{ totalFareAmount }}
                      </span>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </div>
          </div>
        </v-radio-group>
        <!-- </v-card> -->
      </div>
      <div class="drawer-section">
        <div class="offcanvas offcanvas-end" data-bs-backdrop="static" tabindex="-1" id="additionalinformation"
          aria-labelledby="additionalinformationLabel">
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="additionalinformation">
              Additional Information
            </h5>
            <button @click="closeBaggageRules" type="button" class="text-reset" data-bs-dismiss="offcanvas"
              aria-label="Close" color="white">
              <v-icon>mdi-close</v-icon>
            </button>
          </div>
          <div class="offcanvas-body pt-0" style="overflow-x: hidden">
            <v-card class="mt-4">
              <h6 class="mt-2">{{ fareupgradeDataterms?.heading }}:</h6>
              <div class="p-2">
                <div v-html="fareupgradeDataterms?.html_content"></div>
              </div>
            </v-card>
          </div>

        </div>
      </div>
      <div class="mt-2 d-none" v-if="selectedUpgrade === 'standard'">
        <v-card rounted="1" style="padding: 15px 10px">
          <div class="ms-2" style="font-size: 16px; font-weight: 500">
            <span style="font-size: 23px; font-weight: 600">{{
              $t("paymentContent.fareUpgrade.congratsText")
            }}</span>
            {{ $t("paymentContent.fareUpgrade.fareContent1") }}
          </div>
          <div class="ms-2" style="font-size: 14px">
            {{ $t("paymentContent.fareUpgrade.fareContent2") }}
          </div>

          <div class="row gx-0 mt-2">
            <div class="col-sm-9 col-md-10">
              <div class="row gx-0 mt-3">
                <div class="col-md-4" v-for="(data, index) of totalPassData" :key="index">
                  <div style="
                      text-transform: uppercase;
                      font-size: 12px;
                      font-weight: 500;
                      height: 25px;
                      display: flex;
                    ">
                    <span style="position: relative; top: -5px"><v-checkbox size="10" color="success"
                        v-model="data.fareup" @change="updateFare(data, index)"></v-checkbox></span>
                    <span style="
                        display: flex;
                        align-items: center;
                        font-size: 13px;
                        font-weight: 400;
                      ">
                      {{ data.salutation }} {{ data.firstname }}
                      {{ data.middlename }} {{ data.lastname }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-3 col-md-2">
              <div class="d-flex justify-center">
                <v-btn variant="outlined" height="60" width="120" class="fare-btn">
                  <p class="m-0" style="font-size: 20px; font-weight: 600">
                    <span style="font-size: 17px; font-weight: 600">{{
                      currency
                    }}</span>
                    <span style="margin-left: 3px">{{ fareupgradeData }}</span>
                  </p>
                </v-btn>
              </div>
            </div>
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

import { getConfigDataFromLocalStorage } from "@/localStorageData/localStorageUtil.js";
export default {
  props: {
    fareData: {
      type: String,
      required: true,
    },
    passData: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedUpgrade: "basic",
      fareupgradeDataterms: "",
      fareupgrade: [],
      fareupgradeurl: "",
      upgradeFare: "",
      BasicUpgrade: [],
      standartUpgrade: [],
      currency: "",
      countryIso: "",
      faretriptype: "1",
      fareupgradeData: "",
      totalPassData: [],
      selectpass: [],
      selectpassData: "",
      activated: false,
      activated1: true,
      portal_domain: "",
      BasicUpgradeval: false,
      standartval: false,
      fareAdultAmount: "",
      fareEachAmount: "",
      fareChildAmount: "",
      TotalAmount: "",
      textcolor: "",
      slice_value:1,
      textcrosscolor: "",
      showUpgradeContinue: false,
      basicClickedOnce: false,
      previousSelectedUpgrade: "basic",
    };
  },
  methods: {
    getConfig() {
      const getConfigData1 = getConfigDataFromLocalStorage();
      if (getConfigData1) {
        // console.log(getConfigData1, "getConfigData1getConfigData1");

        this.countryIso =
          getConfigData1.payload.portal_configuration.country.iso_code;
        this.fareupgradeurl =
          getConfigData1.payload.portal_configuration.API_endpoints?.fareupgrade;
        this.portal_domain =
          getConfigData1.payload.portal_configuration.portal_url.replace(
            "https://",
            ""
          );
        // console.log(this.fareupgradeurl, "this.fareupgradeurl");

      }
    },

    getFareUpgrade() {
      let FareUpgradereq = {
        offer_id: this.fareupgrade[0].selectId,
        pos: this.countryIso,
        domain: this.portal_domain,
        shopping_response_id: this.fareupgrade[0].ShoppingResponseId,
        source: "portal",
        ip: "121.243.33.212",
      };
      // console.log(FareUpgradereq, this.fareupgradeurl, "vasanth2344");

      axios
        .post(this.fareupgradeurl, FareUpgradereq, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.selectpassData = parseInt(this.selectpassData) || 1;

          // if (this.fareupgrade.triptype == "OneWay") {
          //   this.upgradeFare = 1;
          // } else {
          //   this.upgradeFare = 2;
          // }

          this.fareupgratedata = response.data.data.fare_upgrade_options;
          this.fareEachAmount = response.data.data.fare_upgrade_amount_adt;
          this.fareAdultAmount = response.data.data.fare_upgrade_amount_adt;
          this.fareChildAmount = response.data.data.fare_upgrade_amount_chd;
          this.currency = response.data.data.fare_upgrade_amount_currency;
          this.fareupgradeDataterms = response.data.data?.fare_upgrade_terms;
          this.slice_value = response.data.data.slice_value;
          // console.log(this.fareupgradeDataterms, "vasanth23441");
          // console.log(response, "vasanth2344");
          //   this.fareupgradeData = this.upgradeFare
          this.fareupgratedata.forEach((c) => {
            if (c.option_text == "Basic") {
              this.BasicUpgrade = c;
              this.textcolor = c.textcolor;
              this.textcrosscolor = c.textcrosscolor;

            } else if (c.option_text == "Standard") {
              this.standartUpgrade = c;
              this.textcolor = c.textcolor;
              this.textcrosscolor = c.textcrosscolor;
            } else {
              this.BasicUpgrade = this.fareupgratedata[0];
              this.standartUpgrade = this.fareupgratedata[1];
              this.textcolor = this.fareupgratedata[0].textcolor;
              this.textcrosscolor = this.fareupgratedata[0].textcrosscolor;
            }
          });
          //   console.log(this.BasicUpgrade, "  this.BasicUpgrade");
          //   console.log(this.standartUpgrade, "  this.standartUpgrade");
          //   console.log(response.data.data, "responsefff");

          if (this.BasicUpgrade.feature_list.length > 0) {
            this.BasicUpgradeval = true;
            this.BasicUp(this.BasicUpgrade.feature_list[0]);
          }
          if (this.standartUpgrade.feature_list.length > 0) {
            this.standartval = true;
            this.BasicUp(this.standartUpgrade.feature_list[0]);
          }
        })
        .catch((e) => {
          console.log("Error", e);
        });
    },
    BasicUp(data) {
      // console.log(data, "datadatadata333");
      data.forEach((v) => {
        if (v.bullet == "nobagimage") {
          v.logo = "mdi-bag-suitcase-off-outline";
          v.color = "#008000";
        } else if (v.bullet == "bagimage") {
          v.logo = "mdi-bag-suitcase";
          v.color = "#008000";
        } else if (v.bullet == "cross") {
          v.logo = "mdi-cancel";
          v.color = "#f10404";
        } else if (v.bullet == "dollar") {
          v.logo = "mdi-currency-usd";
          v.color = "#008000";
        } else if (v.bullet == "check") {
          v.logo = "mdi-check-circle-outline";
          v.color = "#008000";
        } else {
          v.logo = "";
        }

        if (v.bullet == "head") {
          v.style = {
            fontsize: "15px",
            fontweight: 500,
          };
        } else {
          v.style = {
            fontsize: "15px",
          };
        }
      });

      //   console.log(data, "datadatadata333");
      return data;
    },

    changeAmount($data) {
      let adult = parseInt(this.fareupgrade[0].Adult || this.fareupgrade[0].adult)
      let chilt = parseInt(this.fareupgrade[0].Child || this.fareupgrade[0].child || 0)
      console.log('Amount Change in fare:', $data, adult, chilt, this.fareAdultAmount)

      if (adult >= $data) {
        this.TotalAmount = $data * this.fareAdultAmount;
      } else {
        let chd = $data - adult;
        this.TotalAmount =
          adult * this.fareAdultAmount + chd * this.fareChildAmount;
      }
      // this.$emit("childValue", this.TotalAmount);
      if (this.selectedUpgrade === "standard") {
        this.$emit("childValue", this.TotalAmount);
        this.$emit("selectPass", $data);
      }
      else {
        this.$emit("selectPass", 0);
      }
      // console.log(this.TotalAmount, "Total");
    },

    basicData() {
      // Only emit if the previous upgrade was standard (i.e., it's a switch back to basic)
      // if (this.previousSelectedUpgrade === 'standard') {
      //   let total = 0;
      //   // this.$emit("childValue", total);
      //   console.log(total)
      // }

      this.activated = true;
      this.activated1 = false;
      // this.previousSelectedUpgrade = 'basic';
    },

    upgradeflowData() {
      if (this.previousSelectedUpgrade !== "standard") {
        this.activated1 = true;
        this.activated = false;
        this.standardClickedOnce = true;
        this.previousSelectedUpgrade = "standard";

        this.showUpgradeContinue = true;
        this.$emit("childValue", this.TotalAmount);
      }
    },
    selectedUpgradeMethod(val) {
      // console.log(val, 'basicvasa');
      this.activated = val === "basic";
      this.activated1 = val === "standard";

      if (val === "basic") {
        this.$emit("childValue", 0);
        this.$emit("selectPass", 0);
        this.$emit("upgradeType", "basic");
        this.$emit("updateAddOnAmount", "0");
      } else if (val === "standard") {
        this.changeAmount(this.selectpassData);
        this.$emit("childValue", this.TotalAmount);
        // console.log("this.totalamounttttttt", this.TotalAmount);
        this.$emit("upgradeType", "standard");
        this.$emit("updateAddOnAmount", this.totalFareAmount);
      }
    },
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 575;
    },
    totalFareAmount() {
      const baseAmount = parseFloat(this.fareEachAmount).toFixed(2) || 0;
      const passengerCount = parseInt(this.selectpassData) || 1;

      // let multiplier = 1;

      // if (this.fareupgrade.length && this.fareupgrade[0].triptype.toLowerCase() === "roundtrip") {
      //   multiplier = 2;
      // } else if (this.fareupgrade.length && this.fareupgrade[0].triptype.toLowerCase() === "multicity") {
      //   // Multicity: 1 leg = 70, 2 legs = 140, 3 legs = 210, 4 legs = 280
      //   // Each leg counts as 1x multiplier (max 4)
      //   multiplier = Math.min(this.fareupgrade.length, 4);
      //   console.log(multiplier,this.fareupgrade,'multiplier')
      // }
      console.log(baseAmount * passengerCount * this.slice_value,baseAmount,passengerCount,this.slice_value,"totalFareAmount")
      return (baseAmount * passengerCount * this.slice_value).toFixed(2);
    },
  },


  watch: {
    totalFareAmount(newVal) {
      if (this.selectedUpgrade === "basic") {
        // If "basic" is selected, set newVal to 0
        this.$emit("upgradeType", "basic");
        this.$emit("updateAddOnAmount", "0");
      } else if (this.selectedUpgrade === "standard") {
        // If "standard" is selected, emit the actual newVal
        this.$emit("upgradeType", "standard");
        this.$emit("updateAddOnAmount", newVal);
      }
    },
    selectpassData(newval) {
      this.changeAmount(newval);
    },
    // selectedUpgrade(val) {
    //   console.log(val,'bacisvasa')
    //   this.activated = val === "basic";
    //   this.activated1 = val === "standard";

    //   if (val === "basic") {
    //     this.$emit("childValue",0);
    //     this.$emit("selectPass", 0);
    //     this.$emit("upgradeType", "basic");
    //      this.$emit("updateAddOnAmount", "0");
    //   } else if (val === "standard") {
    //     this.changeAmount(this.selectpassData);
    //     this.$emit("childValue", this.TotalAmount);
    //     console.log("this.totalamounttttttt", this.TotalAmount);
    //     this.$emit("upgradeType", "standard");
    //     this.$emit("updateAddOnAmount", this.totalFareAmount);
    //   }
    // },
    selectedUpgrade(newVal) {
      this.selectedUpgradeMethod(newVal);
    }
  },
  created() {
    this.getConfig()
    this.fareupgrade = this.fareData

        console.log(this.fareData,'fareDataa')

    this.totalPassData =
      parseInt(this.fareupgrade[0].Adult || this.fareupgrade[0].adult) +
      parseInt(this.fareupgrade[0].Child || this.fareupgrade[0].child || 0);
    // console.log(this.fareupgrade, this.totalPassData,"fareData");
    this.selectpass = Array.from({ length: this.totalPassData }, (_, i) => i + 1);


    if (this.fareupgrade.length > 0) {
      this.getFareUpgrade();
    }
    this.selectedUpgrade = "basic";
    this.previousSelectedUpgrade = "basic";
  },
};
</script>

<style scoped>
.upgradeButton {
  background-color: rgb(225, 237, 241) !important;
  /* box-shadow: 0 0 5px #0b446d; */
}

.act-upgrate {
  box-shadow: 0 0 5px #0b446d;
}

.act-none {
  box-shadow: none;
}

.fare-btn {
  background-color: gold;
  /* color: white; */
}

upgrade:hover {
  background-color: rgb(225, 237, 241);
}

.bt-upgrade {
  background-color: gold;
}

/* .bt-upgrade:hover {
  background-color: rgb(225, 237, 241);
} */

:deep(.v-selection-control) {
  display: flex;
  justify-content: end;
}

.fare-btn {
  background-color: gold;
  /* color: white; */
}

.up-title {
  font-size: 19px;
  font-weight: 500;
}

.up-content {
  font-size: 15px;
  font-weight: 400;
}

.up-title1 {
  font-size: 16px;
  font-weight: 500;
  color: #0b446d;
}

.up-content1 {
  /* font-weight: 500; */
  font-size: 15px;
}

.up-subcontent {
  font-size: 16px;
  font-weight: 500;
}

.check {
  padding: unset !important;
}

/* >>>.check .v-input__control {
  height: 30px;
}

>>>.check .v-field__input {
  min-height: 30px !important;
  padding: 0 8px !important;
} */

.offcanvas-header {
  background: #002d5b !important;
  color: white !important;
  display: flex;
  justify-content: space-between;
}

.offcanvas-header h5 {
  color: white !important;
}

@media screen and (max-width: 430px) {
  .drawer-section .offcanvas {
    width: 100% !important;
  }
}

drawer-section .v-timeline--vertical.v-timeline {
  grid-row-gap: 24px !important;
}

drawer-section .v-timeline {
  justify-content: left !important;
}

.drawer-section .v-list-item__content {
  display: flex !important;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}

.drawer-section .text-reset:hover {
  color: red !important;
  background: white;
  border-radius: 8px;
}

.drawer-section .offcanvas-backdrop.show {
  pointer-events: none !important;
}

.drawer-section .v-slide-group__content {
  display: flex;
  justify-content: space-evenly;
}

.drawer-section .v-slide-group__content .v-btn {
  height: 45px !important;
}

.drawer-section .v-slide-group__content .v-btn__content {
  font-size: 12px;
}

.drawer-section .v-slide-group__content {
  background: #f3f1f1;
  height: 50px;
}

.drawer-section .v-slide-group__content .v-slide-group-item--active .v-btn__content {
  color: #002d5b !important;
}

.drawer-section .v-timeline-divider__inner-dot {
  background: #002d5b !important;
}

.drawer-section .v-timeline--vertical.v-timeline {
  grid-row-gap: 24px;
}

.drawer-section .v-timeline--vertical.v-timeline {
  /* grid-row-gap: 24px; */
  height: auto !important;
}

/* .drawer-section .offcanvas {
  width: 35%;
} */
/* :deep(#input-47-messages #input-83-messages){
  grid-area:unset !important;
  padding-inline:unset !important;
} */
:deep(.v-input__details){
   grid-area:unset !important;
}
:deep(.v-radio-group .v-input__details ){
   padding-inline:unset !important;
}
</style>
